import React from 'react';
import styled from 'styled-components';
import { colors, typoGraphy } from '../../../stylesheets';
import { Text } from '../../kit';
import {
  getBackgroundColor,
  getPlaceHolderColor,
} from '../../../utils/getTextareaColors';

type Props = {
  className?: string,
  onChange: Function,
  placeHolder: string,
  disabled: boolean,
  error?: string,
  handleBlur?: Function,
};

const StyledWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const StyledTextArea = styled.textarea`
    width: 100%;
    border-radius: 10px;
    direction: rtl;
    color:${(props) => (props.error ? colors['red'] : colors['blackText'])};
    background: ${(props) => getBackgroundColor(props)};
    border: 1px solid ${(props) =>
      !props.error ? colors['lightGray'] : colors['lightPrimary']};
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};  
    padding: 5px 10px;
    min-height: 80px;
    
    ${typoGraphy['sm']};
      &::placeholder {
        color: ${(props) => getPlaceHolderColor(props)};
        ${typoGraphy['sm']};
      }
    }
`;

const StyledErrorMessage = styled(Text)`
  position: absolute;
  bottom: -25px;
  right: 10px;
`;

const TextArea = ({
  className,
  placeHolder,
  onChange,
  handleBlur,
  disabled,
  label,
  name,
  error,
  labelClassName,
  textAreaClassName,
  is_bold=false,
  ...restProps
}: Props) => {
  return (
    <StyledWrapper className={className}>
      {label ? (
        <>
          <Text
            type="label"
            htmlFor={name}
            size="md"
            className={`mb-1 w-100 ${labelClassName} ${
              error ? 'has-error' : ''
            }`}
            bold={is_bold}
          >
            {label}
          </Text>
          {/* {error ? (
            <span className="px-1 font-xs text-red">- {error}</span>
          ) : null} */}
        </>
      ) : null}
      <StyledTextArea
        onBlur={handleBlur}
        placeholder={placeHolder}
        onChange={(e) => onChange(e, e.target.value)}
        disabled={disabled}
        name={name}
        className={textAreaClassName}
        {...restProps}
      />
      {error && (
        <StyledErrorMessage size="xs" color="red" className="mr-2" dir="rtl">
          * {error}
        </StyledErrorMessage>
      )}
    </StyledWrapper>
  );
};

TextArea.defaultProps = {
  disabled: false,
  handleBlur: () => {},
};

export default TextArea;
